<template>
  <center-panel
    :panel-style="{
      height: '300px',
      backgroundColor: 'white'
    }"
  >
    <div class="panel-content">
      <h1 class="error-text is-size-3 has-text-danger">
        Network Error!
      </h1>
      <font-awesome-layers
        class="fa-stack fa-icon-stack"
        size="3x"
        :style="{textAlign: 'center'}"
      >
        <span class="image-wrapper">
          <font-awesome-icon
            icon="globe"
            color="grey"
            class="globe-icon"
            size="3x"
          />
          <font-awesome-icon
            icon="times"
            class="times-icon"
            color="red"
            size="2x"
          />
        </span>
      </font-awesome-layers>
      <p class="error-text">
        Sorry, but we are unable to connect to the server right now.
      </p>
    </div>
  </center-panel>
</template>

<script>
import CenterPanel from '@/components/Shared/CenterPanel'
export default {

  name: 'NetworkError',
  components: {
    CenterPanel
  },
  data () {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
.fa-icon-stack {
  position: relative;
  .times-icon, .globe-icon {
    position: absolute;
  }

  .times-icon {
    right: -8px;
    animation-duration: .8s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
    animation-name: throb;
    animation-timing-function: linear;
  }
}
.error-text {
  text-align: center;
  color: black;
}

.panel-content {
  padding: 30px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}
</style>
